
import { ContentsDocument } from '@platyplus/rxdb-hasura'
import { defineComponent, PropType, toRefs } from 'vue'

import { useRefFieldValue } from '../../../composables'

export default defineComponent({
  name: 'FieldReadManyToMany',
  props: {
    document: {
      type: Object as PropType<ContentsDocument>,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props) {
    const { name, document } = toRefs(props)
    const refCollection = useRefFieldValue<Array<ContentsDocument>>(
      document,
      name
    )
    return { refCollection }
  }
})
